<template>
    <div class="container-fluid">
        <div style="padding-top:6%;"></div>
        <div class="online-appointment" id="online_appointment" v-show="allowOnlineBooking">
            <div id="booking_title" class="page-title text-center">
                <h1>Online Appointment Booking</h1>
                <div class="sub-title">Please fill the form below to book online service booking for your vehicle</div>
            </div>
            <div class="row mt-5">
                <div class="col-md-8 offset-md-2">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="nav nav-tabs booking-steps" id="nav-tab" role="tablist">
                                <a class="nav-link active" id="customer-details-tab" v-on:click.prevent="moveToCusDetailsPage()" href="javascript:;">
                                    <span class="vertical-bar step1">
                                        <div class="steps"></div>
                                        <div class="step-dots"></div>
                                        <div class="step-dots"></div>
                                    </span>
                                    <div class="step-name">Select Customer Details</div>
                                </a>
                                <a class="nav-link" id="select-services-tab" v-on:click.prevent="moveToSelectServicePage()" href="javascript:;">
                                    <span class="vertical-bar step2">
                                        <div class="steps"></div>
                                        <div class="step-dots"></div>
                                        <div class="step-dots"></div>
                                    </span>
                                    <div class="step-name">Select Services</div>
                                </a>
                                <a class="nav-link" id="select-date-tab" v-on:click.prevent="moveToSelectDatePage()" href="javascript:;">
                                    <span class="vertical-bar step3">
                                        <div class="steps"></div>
                                    </span>
                                    <div class="step-name">Select Date & Book</div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-8 tab-content">
                            <div id="customer_details" class="tab-pane fade show active" role="tabpanel">
                                <div class="row">
                                    <div class="col-md-8">
                                        <div class="form-group mb-4 booking_select">
                                            <label for="">Location</label>
                                            <v-select title="Select Location"
                                                v-model="appointmentData.location"
                                                name="location"
                                                id="location"
                                                label="text"
                                                :clearable="false"
                                                :searchable="false"
                                                :filterable="false"
                                                :options="locationOptions"
                                                placeholder="Select Location"
                                                @input="onLocationChange"
                                            >
                                            </v-select>
                                            <span class="text-danger">{{locationError}}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4"></div>
                                    <div class="col-md-6">
                                        <div class="form-group mb-4 booking_select">
                                            <label for="">Department</label>
                                            <v-select title="Select Department"
                                                v-model="appointmentData.department"
                                                name="department"
                                                id="department"
                                                label="text"
                                                :clearable="false"
                                                :searchable="false"
                                                :filterable="false"
                                                :options="departmentOptions"
                                                placeholder="Select Department"
                                                @input="onDepartmentChange"
                                            >
                                            </v-select>
                                            <span class="text-danger">{{departmentError}}</span>
                                        </div>    
                                    </div>
                                    <div class="col-md-6"></div>
                                    <div class="col-md-6">
                                        <div class="form-group input-registration">
                                            <label for="">Enter Registration ID</label>
                                            <div class="input-group">
                                                <input @input="regIDError = ''" type="text" v-model="appointmentData.reg_no" class="form-control" aria-label="Enter Registration ID" aria-describedby="btnGroupAddon" maxlength="20" :disabled="isRegIdisabled">
                                                <div class="input-group-text" id="btnGroupAddon" v-on:click.prevent="fetchDetailsFromExcede()" v-if="!isRegIdisabled" style="cursor: pointer;"><i class="fa fa-cloud-upload color-light-green" aria-hidden="true"></i>&nbsp; Search Vehicle</div>
                                            </div>
                                            <div class="text-danger">{{regIDError}}</div>
                                        </div>    
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="">VIN</label>
                                            <div class="input-group">
                                                <input type="text" v-model="appointmentData.vin" class="form-control" aria-label="Enter Registration ID" aria-describedby="btnGroupAddon" maxlength="20" disabled>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="form-group mb-4 booking_select">
                                            <label for="">Make</label>
                                            <v-select title="Select Make"
                                                    v-model="appointmentData.make"
                                                    name="make"
                                                    id="make"
                                                    label="text"
                                                    :clearable="false"
                                                    :searchable="false"
                                                    :filterable="false"
                                                    :options="makeOptions"
                                                    @input="onMakeChange()"
                                                    placeholder="Select Make"
                                                    >
                                            </v-select>
                                            <span class="text-danger">{{makeError}}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="">Current KMs</label>
                                            <input @input="odomInError = ''" type="number" v-model="appointmentData.odomIn" class="form-control" maxlength="10" min="1">
                                            <span class="text-danger">{{odomInError}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-8">
                                        <div v-if="!otherMakeSelected" class="form-group mb-4 booking_select">
                                            <label for="">Model</label>
                                            <v-select
                                                    v-model="appointmentData.model"
                                                    name="model"
                                                    id="model"
                                                    label="text"
                                                    :clearable="false"
                                                    :searchable="false"
                                                    :filterable="false"
                                                    :options="modelOptions"
                                                    @input="onModelChange()"
                                                    placeholder="Select Model"
                                                    >
                                                    <template v-slot:no-options>
                                                            Please Select Make First
                                                    </template>
                                            </v-select>
                                            <span class="text-danger">{{modelError}}</span>
                                        </div>
                                        <div v-else class="form-group">
                                            <label for="">Other Detail</label>
                                            <textarea @input="makeDetailError = ''" v-model="appointmentData.makeOtherDetail" rows="2" class="form-control" maxlength="500"></textarea>
                                            <span class="text-danger">{{makeDetailError}}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="">Year</label>
                                            <input @input="yearError = ''" type="text" v-model="appointmentData.year" class="form-control" maxlength="4" disabled>
                                            <span class="text-danger">{{yearError}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-8">
                                        <div class="form-group">
                                            <label for="">Customer Name</label>
                                            <input @input="cusNameError = ''" type="text" v-model="appointmentData.cus_name" class="form-control" maxlength="200" disabled>
                                            <span class="text-danger">{{cusNameError}}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="">Contact Detail</label>
                                            <input @input="cusContactError = ''" type="text" v-model="appointmentData.cus_contact_no" class="form-control" maxlength="10" :disabled="isPhoneDisabled">
                                            <span>Enter a mobile number in 0xxxxxxxxx format</span>
                                            <span class="text-danger">{{cusContactError}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-8">
                                        <div class="form-group">
                                            <label for="">Email</label>
                                            <input @input="cusEmailError = ''" type="email" v-model="appointmentData.cus_email" class="form-control" maxlength="200" :disabled="isEmailDisabled">
                                            <span class="text-danger">{{cusEmailError}}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="">Customer Id</label>
                                            <input type="text" v-model="appointmentData.customer_id" class="form-control" maxlength="10" disabled>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-4">
                                    <div class="col-lg-6 offset-lg-2">
                                        <button type="button" class="btn btn-primary w-100" v-on:click.prevent="moveToSelectServicePage()">
                                            Continue 
                                            <span class="arrow-line"></span>
                                            <i class="arrow-right"></i> 
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div id="select_services" class="tab-pane fade" role="tabpanel">
                                <div class="row">
                                    <div class="col-md-12">
                                        <label for="">Service Type</label>
                                    </div>
                                </div>
                                <!-- if make is Freightliner -->
                                <div v-if="appointmentData.make.value == 1">
                                    <div class="row" v-for="(service,index) in serviceTypeOptions" :key="index">
                                        <div class="col-md-10 col-10">
                                            <input @change="changedFrightlinerServiceType()" type="checkbox" :id="'service' + index" :name="service.text" :value="service.text" v-model='appointmentData.service_data.freightliner_service_type'>
                                            <span class="form-label" :for="service.text">{{ service.text }}</span>
                                        </div>
                                    </div>
                                    <span class="text-danger">{{freightlinerServiceTypeError}}</span>
                                    <div style="padding-bottom: 30px;"></div>
                                </div>
                                <!-- if make is Other -->
                                <div v-else-if="appointmentData.make.value == 0" class="row">
                                    <div class="col-md-10 col-10">
                                        <div class="form-group">
                                            <input @input="otherMakeTypeError = ''" type="text" v-model="appointmentData.service_data.other_make_service_type" class="form-control" maxlength="200">
                                            <span class="text-danger">{{otherMakeTypeError}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="row">
                                    <div class="col-md-10 col-10">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group booking_select">
                                                    <v-select title="Select Service"
                                                            v-model="appointmentData.service_data.service_type"
                                                            name="service_type[index]"
                                                            id="location[index]"
                                                            label="text"
                                                            :clearable="false"
                                                            :searchable="false"
                                                            :filterable="false"
                                                            :options="serviceTypeOptions"
                                                            placeholder="Select Service">
                                                    </v-select>
                                                    <span class="text-danger">{{serviceTypeError}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-10 col-10">
                                        <div class="form-group">
                                            <label for="">Additional Details / Requests</label>
                                            <textarea @input="serviceDescriptionError = ''" v-model="appointmentData.service_data.service_description" placeholder="Comment" rows="2" class="form-control" maxlength="1000"></textarea>
                                            <span class="text-danger">{{serviceDescriptionError}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-5">
                                    <div class="col-md-4">
                                        <div class="col-lg-6 offset-lg-1">
                                            <button type="button" class="btn btn-primary w-100" v-on:click.prevent="moveToCusDetailsPage()">
                                                <i class="arrow-left"></i> 
                                                <span class="arrow-line-for-left"></span>
                                                Back 
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="col-lg-6 offset-lg-0">
                                            <button type="button" class="btn btn-primary w-100" v-on:click.prevent="moveToSelectDatePage()">
                                                Continue 
                                                <span class="arrow-line"></span>
                                                <i class="arrow-right"></i> 
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="select_date" class="tab-pane fade" role="tabpanel">
                                <div id="booking_appointment" class="book-appointment">
                                    <div>
                                        <full-calendar id="serviceCalendar" class="serviceCalendar" :events="events" :config="config" ref="calendar"></full-calendar>
                                        <div class="text-danger">{{calendarError}}</div>
                                        <div class="static_note">If there is no availability on your desired date, please ring us directly <br> on {{ appointmentData.location.contact_no }}</div>
                                    </div>

                                    <div class="row mt-4 mb-4">
                                        <div class="col-md-auto">
                                            <div class="not-available-color"></div>
                                            <span class="color-text">Not Available</span>
                                        </div>
                                        <div class="col-md-auto">
                                            <div class="available-color"></div>
                                            <span class="color-text">Available</span>
                                        </div>
                                        <div class="col-md-auto">
                                            <div class="selected-color"></div>
                                            <span class="color-text">Selected</span>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Preferred Drop Off Time</label>
                                                <date-picker @input="dropTimeError = ''"
                                                            v-model="appointmentData.preferredDropTime"
                                                            use12-hour="true"
                                                            :config="optionsTime" 
                                                            class="form-control"
                                                            id="dropTime">
                                                </date-picker>
                                                <span class="text-danger">{{dropTimeError}}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mt-4">
                                        <div class="col-md-6">
                                            <div class="col-lg-6 offset-lg-4">
                                                <button type="button" class="btn btn-primary w-100" v-on:click.prevent="moveToSelectServicePage()">
                                                    <i class="arrow-left"></i> 
                                                    <span class="arrow-line-for-left"></span>
                                                    Back 
                                                </button>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="col-lg-6 offset-lg-3">
                                                <div v-if="appointmentData.selectedDate">
                                                    <button type="button" class="btn btn-primary w-100" v-on:click.prevent="moveToBookingSuccessPage()">
                                                    Book 
                                                    </button>
                                                </div>
                                                <div v-else>
                                                    <a type="button" title="Please select date" class="btn disabled_button w-100">
                                                    Book 
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="booking_success" class="booked-successfully hide">
                                    <div class="row">
                                        <div class="col-lg-8 offset-lg-2">
                                            <img src="/static/images/Group 37301.png" alt="">
                                            <p>
                                                <h5 class="bold">Appointment Booked Successfully</h5>
                                            </p>
                                            <p>
                                                Congratulations! Your appointment for vehicle service has been booked successfully. Sit back, relax, and let our expert team take care of your vehicle. We're committed to providing top-notch service and ensuring your vehicle is in excellent hands. 🚗💨
                                            </p>
                                            <div class="col-lg-6 offset-lg-2">
                                                <button type="button" class="btn btn-primary w-100" v-on:click.prevent="resetAppointmentData()">
                                                    Back to home
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="Overbooked_notification_for_calendar" class="hide">
                                <div style="padding-top:6%;"></div>
                                <h4><center>To book appointment, please ring us directly on {{ appointmentData.location.contact_no }}</center></h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="Overbooked_notification" v-show="!allowOnlineBooking">
            <div style="padding-top:6%;"></div>
            <h4><center>To book appointment, please ring us directly on {{ appointmentData.location.contact_no }}</center></h4>
        </div>
        <app-footer></app-footer>
    </div>
</template>
<script>

    import Footer from '@/components/partials/Footer';
    import {HTTP} from '../http-common';
    import {commonMixins,isPromise} from '../mixins/commonMixins';
    import vSelect from 'vue-select';
    import { FullCalendar } from 'vue-full-calendar';
    import 'fullcalendar/dist/fullcalendar.css';
    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
    var self;
    
    export default {
        name: 'Login',
        mixins: [commonMixins],
        components: {
            'app-footer': Footer,
            'v-select': vSelect,
            'full-calendar': FullCalendar,
            datePicker 
        },
        data() {
            return {
                isTouchDevice:false,
                allowOnlineBooking:true,//to disable customer detail page if first 3 weeks are full
                firstLocSelected:true,//By default it selects location which has id = 23
                firstCheckCalendarEvents:true,//to check -first 3 weeks full- based on service hours or received backend response.
                isServiceSelected:true,//to call service api or not based on service is selected or not
                isPrevNextClicked:false,//if used clicks on prev or next button on full calendar 
                isServiceTypeHoursChanged:false,//user changes service and its hours are changed or not.Based on that it forces calendar for today.
                isAllSaturdayDisable:false,//if sat store time is blank in TSS than disable all saturday.
                locationError:'',
                otherMakeSelected:false,
                regIDError:'',
                makeError:'',
                modelError:'',
                makeDetailError:'',
                yearError:'',
                odomInError:'',
                cusNameError:'',
                cusContactError:'',
                cusEmailError:'',
                dropTimeError:'',
                calendarError:'',
                serviceTypeError:'',
                otherMakeTypeError:'',
                freightlinerServiceTypeError:'',
                serviceDescriptionError:'',
                locationOptions:[],
                serviceTypeOptions:[
                    {
                        'text': '15K',
                        'value': 3
                    },
                    {
                        'text': '30K',
                        'value': 3
                    },
                    {
                        'text': '45K',
                        'value': 3
                    },
                    {
                        'text': '60K',
                        'value': 6
                    },
                    {
                        'text': '75K',
                        'value': 3
                    },
                    {
                        'text': '90K',
                        'value': 3
                    },
                    {
                        'text': '105K',
                        'value': 3
                    },
                    {
                        'text': '120K',
                        'value': 6
                    },
                    {
                        'text': '135K',
                        'value': 3
                    },
                    {
                        'text': '150K',
                        'value': 3
                    },
                    {
                        'text': '165K',
                        'value': 3
                    },
                    {
                        'text': '180K',
                        'value': 6
                    },
                    {
                        'text': '195K',
                        'value': 3
                    },
                    {
                        'text': '210K',
                        'value': 3
                    },
                    {
                        'text': '225K',
                        'value': 3
                    },
                    {
                        'text': '240K',
                        'value': 6
                    },
                    {
                        'text': '255K',
                        'value': 3
                    },
                    {
                        'text': '270K',
                        'value': 3
                    },
                    {
                        'text': '285K',
                        'value': 3
                    },
                    {
                        'text': '300K',
                        'value': 6
                    }
                ],
                makeOptions:[],
                modelOptions:[],
                allModelList:[],
                appointmentData:{
                    location:'',
                    isCustomerNew:false,
                    reg_no:'',
                    make:'',
                    model:'',
                    makeOtherDetail:'',
                    year:'',
                    odomIn:'',
                    cus_name:'',
                    cus_contact_no:'',
                    cus_email:'',
                    service_data:{
                        service_type: {'text': '15K', 'value': 3},
                        other_make_service_type:'',
                        freightliner_service_type:[],
                        service_description:'',
                    },
                    totalJobHours:0.0,
                    job_make_detail:'',
                    preferredDropTime:'07:30 AM',
                    selectedDate:'',
                    lastSelectedDate:'', //To store previously selected not available date
                    unsold_hrs : '',
                    customer_id: null,
                    vin: null,
                    department: null,
                    fleet_unit_id: null
                },
                events: [],
                holidayList:[],
                startDate: '',
                endDate: '',
                optionsTime: {
                    format: 'hh:mm A',
                    stepping: 15,
                },
                config: {
                    html: true,
                    unselectAuto:false,
                    // longPressDelay:1000,
                    // eventDisplay:'none',
                    defaultDate: moment(new Date()).format("YYYY-MM-DD"),
                    defaultView: 'month',
                    displayEventTime: false,
                    editable: false,
                    eventLimit: true,
                    selectable: true,
                    noEventsMessage: "Calendar Events Not Available",
                    dayClick: (date, jsEvent, view) => {
                        self.appointmentData.selectedDate = '';
                        var selectDate = moment(date).format("YYYY-MM-DD");
                        var currentDate = moment(new Date()).format("YYYY-MM-DD");
                        if(self.isTouchDevice){
                            $('.fc-day-top').removeClass('fc-highlight');
                            $('.fc-bg .fc-day').removeClass('fc-highlight');
                            $("td[data-date=" + selectDate + "]").addClass('fc-highlight');
                        }
                        // console.log("Hello",selectDate)
                        self.appointmentData.lastSelectedDate = selectDate;
                        if(self.holidayList.includes(selectDate)){
                            if(self.isTouchDevice){
                                alert('If there is no availability on your desired date, please ring us directly on ' + self.appointmentData.location.contact_no);
                            }else{
                                self.showSAlert('If there is no availability on your desired date, please ring us directly on ' + self.appointmentData.location.contact_no, '', false);
                            }
                            return false;
                        }
                        let day_name = moment(date).format('dddd');
                        if(day_name == 'Sunday'){
                            if(self.isTouchDevice){
                                alert('If there is no availability on your desired date, please ring us directly on ' + self.appointmentData.location.contact_no);
                            }else{
                                self.showSAlert('If there is no availability on your desired date, please ring us directly on ' + self.appointmentData.location.contact_no, '', false);
                            }
                            return false;
                        }
                        if(day_name == 'Saturday'){
                            if(self.isAllSaturdayDisable){
                                if(self.isTouchDevice){
                                    alert('If there is no availability on your desired date, please ring us directly on ' + self.appointmentData.location.contact_no);
                                }else{
                                    self.showSAlert('If there is no availability on your desired date, please ring us directly on ' + self.appointmentData.location.contact_no, '', false);
                                }
                                return false;
                            }
                        }
                        if(selectDate <= currentDate) {
                            if(self.isTouchDevice){
                                alert('If there is no availability on your desired date, please ring us directly on ' + self.appointmentData.location.contact_no);
                            }else{
                                self.showSAlert('If there is no availability on your desired date, please ring us directly on ' + self.appointmentData.location.contact_no, '', false);
                            }
                            return false;
                        }else {
                            var isFullAppointment = false;
                            $.each(self.events, function (i) {
                                if(self.events[i].backgroundColor == "#fc0320" && self.events[i].start == selectDate){
                                    isFullAppointment = true;
                                }
                                if(self.events[i].start == selectDate && (typeof(self.events[i].unsold_hrs) == undefined || self.events[i].unsold_hrs < self.appointmentData.totalJobHours)){
                                    isFullAppointment = true;
                                }
                                if(self.events[i].start == selectDate){
                                    self.appointmentData.unsold_hrs = self.events[i].unsold_hrs;
                                }
                            });
                            if(isFullAppointment){
                                if(self.isTouchDevice){
                                    alert('If there is no availability on your desired date, please ring us directly on ' + self.appointmentData.location.contact_no);
                                }else{
                                    self.$refs.calendar.fireMethod('unselect');
                                    self.showSAlert('If there is no availability on your desired date, please ring us directly on ' + self.appointmentData.location.contact_no, '', false);
                                }
                                return false;
                            }
                        }
                        self.appointmentData.selectedDate = selectDate;
                    },
                    header: {
                        left: 'prev',
                        center: 'title',
                        right: 'next',
                    },
                    buttonText: {
                        'prev': '<',
                        'next': '>',
                    },
                },
                isPhoneDisabled: true,
                isEmailDisabled: true,
                departmentError: null,
                departmentOptions: [],
                isRegIdisabled: true
            }
        },
        created: function () {
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
            self.endDate = self.$refs.calendar.fireMethod('getView').end.format();
            self.firstLocSelected = true;
            self.firstCheckCalendarEvents = true;
            let urlParams = self.$route.query;
            if(urlParams && Object.keys(urlParams).length > 0){
                localStorage.setItem('urlParams', JSON.stringify(urlParams));
                self.$router.replace({ path: self.$route.path });
            }else{
                if (!self.$route.path.includes('customer-portal')) {
                   urlParams = {}
                   localStorage.setItem('urlParams', JSON.stringify(urlParams));
                }
            }
            let params = JSON.parse(localStorage.getItem('urlParams'));
            if (params && params.vin && params.reg_id != 'null') {
                self.getServiceBookingDetails(params);
            } else {
                self.isRegIdisabled = false;
            }
            self.getLocation();
            self.getMakeModelList();
            // In touch devices sweet alert is not working so used alert,also green colour is not coming on selected date so fixed it.
            self.isTouchDevice = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0));
            // $(window).width() < 1025
        },
        methods: {
            changedFrightlinerServiceType(){
                self.freightlinerServiceTypeError = '';
                if(self.appointmentData.service_data.freightliner_service_type.includes("Other/Unsure")){
                    self.appointmentData.service_data.freightliner_service_type = ['Other/Unsure'];
                    $.each(self.serviceTypeOptions, function (key, service) {
                        if(service.text != 'Other/Unsure'){
                            $('#service' + key).prop('checked', false);
                        }
                    });
                }
            },

            getLocation(){
                var config = {
                    headers: {
                    },
                };
                HTTP.get("/getLocation", config)
                    .then(function (data) {
                        if (data.status == 200) {
                            self.locationOptions = data.data.location;
                        }
                        // if(self.firstLocSelected){
                        //     $.each(self.locationOptions, function (key, loc) {
                        //         if(loc.value == 23){
                        //             self.appointmentData.location = loc;
                        //         }
                        //     });
                        //     self.firstLocSelected = false;
                        //     self.getCalendarEvents();
                        // }
                        // self.getCalendarEvents();
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },

            getServiceTimes(){
                self.showLoader();
                var config = {
                    headers: {
                    },
                    params : {
                        make_id: self.appointmentData.make.value,
                        model_id: self.appointmentData.model.value,
                    }
                };
                HTTP.get("/getServiceTimes", config)
                    .then(function (data) {
                        self.hideLoader();
                        if (data.status == 200) {
                            self.serviceTypeOptions = data.data.serviceTimes;
                            self.serviceTypeOptions.push({value:8,text:'Other/Unsure'});
                            if(self.appointmentData.make.value != 1 && self.appointmentData.make.value != 0){
                                self.appointmentData.service_data.service_type = self.serviceTypeOptions[0];
                            }
                        }
                    })
                    .catch(function (error) {
                        self.hideLoader();
                        console.log(error);
                    })
            },

            getMakeModelList(){
                var config = {
                    headers: {
                    },
                };
                HTTP.get("/getMakeModelList", config)
                    .then(function (data) {
                        if (data.status == 200) {
                            self.makeOptions = data.data.makeList;
                            self.allModelList = data.data.modelList;
                            $.each(self.allModelList, function (key, model) {
                                if(self.appointmentData.make.value == model.make_id) {
                                    self.modelOptions.push(model);
                                }
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },

            onMakeChange(){
                self.makeError = '';
                self.modelOptions = [];
                self.appointmentData.model = '';
                if(self.appointmentData.make.value == 0){
                    self.otherMakeSelected = true;
                }else{
                    self.otherMakeSelected = false;
                    $.each(self.allModelList, function (key, model) {
                        if(self.appointmentData.make.value == model.make_id){
                            self.modelOptions.push(model);
                        }
                    });
                }
                self.isServiceSelected = false; //call getServiceApi again

                self.$refs.calendar.fireMethod('today');
                if(self.isTouchDevice){
                    $('.fc-day-top').removeClass('fc-highlight');
                    $('.fc-bg .fc-day').removeClass('fc-highlight');
                }else{
                    self.$refs.calendar.fireMethod('unselect');
                }
                self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
                self.endDate = self.$refs.calendar.fireMethod('getView').end.format();
                self.isPrevNextClicked = false;
                self.appointmentData.lastSelectedDate = '';
            },
            onModelChange(){
                self.modelError = '';
                self.isServiceSelected = false; //call getServiceApi again
                self.$refs.calendar.fireMethod('today');
                if(self.isTouchDevice){
                    $('.fc-day-top').removeClass('fc-highlight');
                    $('.fc-bg .fc-day').removeClass('fc-highlight');
                }else{
                    self.$refs.calendar.fireMethod('unselect');
                }
                self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
                self.endDate = self.$refs.calendar.fireMethod('getView').end.format();
                self.isPrevNextClicked = false;
                self.appointmentData.lastSelectedDate = '';
            },
            
            validateCusDetails(){
                var checked = true;
                self.locationError = '';
                self.regIDError = '';
                self.makeError = '';
                self.modelError = '';
                self.yearError = '';
                self.odomInError = '';
                self.cusNameError = '';
                self.cusContactError = '';
                self.cusEmailError = '';
                
                if(self.appointmentData.location == null || !self.appointmentData.location.value){
                    self.locationError = 'Please Select Location';
                    checked = false;
                }
                if(!self.appointmentData.reg_no){
                    self.regIDError = 'Registration No Required';
                    checked = false;
                }
                if(!self.appointmentData.make){
                    self.makeError = 'Make Required';
                    checked = false;
                }
                if(self.appointmentData.make && self.appointmentData.make.value == 0){
                    if(!self.appointmentData.makeOtherDetail){
                        self.makeDetailError = 'Make Details Required';
                        checked = false;
                    }
                }else{
                    if(!self.appointmentData.model){
                        self.modelError = 'Model Required';
                        checked = false;
                    }
                }
                if(!self.appointmentData.odomIn){
                    self.odomInError = 'Current KMs Required';
                    checked = false;
                }
                if(self.appointmentData.odomIn == 0) {
                    self.odomInError = "Current KMs should be greater than 0";
                    checked = false;
                }
                if(!self.appointmentData.year){
                    self.yearError = 'Year Required';
                    checked = false;
                }
                if(self.appointmentData.year && !self.validNumeric(self.appointmentData.year)) {
                    self.yearError = "Numeric Required";
                    checked = false;
                }
                if(!self.appointmentData.cus_name){
                    self.cusNameError = 'Name Required';
                    checked = false;
                }

                if(!self.appointmentData.cus_contact_no){
                    self.cusContactError = 'Contact No Required';
                    checked = false;
                }else{
                    if(!self.validNumeric(self.appointmentData.cus_contact_no)) {
                        self.cusContactError = "Numeric Required";
                        checked = false;
                    }else if(self.appointmentData.cus_contact_no.length != 10) {
                        self.cusContactError = "Contact no length should be 10 characters";
                        checked = false;
                    }else if(self.appointmentData.cus_contact_no.charAt(0) != "0") {
                        self.cusContactError = "Contact no should start with 0";
                        checked = false;
                    }
                }

                if(!self.appointmentData.cus_email){
                    self.cusEmailError = 'Email Required';
                    checked = false;
                }else{
                    if(!self.validEmail(self.appointmentData.cus_email)) {
                        self.cusEmailError = "Please Enter Valid Email";
                        checked = false;
                    }
                }

                if(self.appointmentData.department == null || !self.appointmentData.department.value) {
                    self.departmentError = 'Please Select Department';
                    checked = false;
                }
                return checked;
            },
            validateService(){
                var checked = true;
                self.freightlinerServiceTypeError = '';
                self.serviceTypeError = '';
                self.serviceDescriptionError = '';
                if(self.appointmentData.make.value == 1){
                    if(self.appointmentData.service_data.freightliner_service_type.length == 0){
                        self.freightlinerServiceTypeError = 'Please select atleast one service type';
                        checked = false;
                    }
                }else{
                    if(!self.appointmentData.service_data.service_type){
                        self.serviceTypeError = 'Please select service type';
                        checked = false;
                    }
                }
                return checked;
            },
            check3weeksBooked(){
                var currentDate = moment(new Date());
                var threeWeeksLater = currentDate.clone().add(3, 'weeks');
                let isOverBooked = [];
                $.each(self.events, function (i) {
                    for (let date = currentDate.clone(); date.isSameOrBefore(threeWeeksLater); date.add(1, 'day')) {
                        const formattedDate = date.format('YYYY-MM-DD');
                        if(self.events[i].start == formattedDate){
                            if(self.firstCheckCalendarEvents){
                                if(self.events[i].backgroundColor == "#fc0320"){
                                    isOverBooked.push('yes');
                                }else{
                                    isOverBooked.push('no');
                                }
                            }else{
                                if((typeof(self.events[i].unsold_hrs) != undefined) && self.events[i].unsold_hrs >= self.appointmentData.totalJobHours){
                                    isOverBooked.push('no');                                    
                                }else{
                                    isOverBooked.push('yes');
                                }
                            }
                        }
                    }
                });
                if(isOverBooked.includes('no')){
                    return false;
                }
                return true;
            },
            validateDateDetails(){
                var checked = true;
                self.dropTimeError = '';
                self.calendarError = '';
                if(!self.appointmentData.selectedDate){
                    self.calendarError = 'Please select Date';
                    return false;
                }
                let day_name = moment(self.appointmentData.selectedDate).format('dddd');
                let dropTime = new Date(Date.parse(self.appointmentData.selectedDate + ' '  + self.appointmentData.preferredDropTime));

                let loc_open_time = '';
                let loc_close_time = '';
                $.each(self.locationOptions, function (key, loc) {
                    if(loc.value == self.appointmentData.location.value){
                        if(day_name == 'Sunday'){
                            if(self.isTouchDevice){
                                alert('If there is no availability on your desired date, please ring us directly on ' + self.appointmentData.location.contact_no);
                            }else{
                                self.showSAlert('If there is no availability on your desired date, please ring us directly on ' + self.appointmentData.location.contact_no, '', false);
                            }
                            checked = false;
                        }else if(day_name == 'Saturday'){
                            if(self.isAllSaturdayDisable){
                                if(self.isTouchDevice){
                                    alert('If there is no availability on your desired date, please ring us directly on ' + self.appointmentData.location.contact_no);
                                }else{
                                    self.showSAlert('If there is no availability on your desired date, please ring us directly on ' + self.appointmentData.location.contact_no, '', false);
                                }
                                checked = false;
                            }else{
                                loc_open_time = new Date(Date.parse(self.appointmentData.selectedDate + ' '  + loc.saturday_opening_time));
                                loc_close_time = new Date(Date.parse(self.appointmentData.selectedDate + ' '  + loc.saturday_closing_time));
                                if(!(dropTime >= loc_open_time && dropTime <= loc_close_time)){
                                    self.dropTimeError = 'Store time is ' + loc.saturday_opening_time + '-' + loc.saturday_closing_time + '. Please select between that.';
                                    checked = false;
                                }
                            }
                        }else{
                            loc_open_time = new Date(Date.parse(self.appointmentData.selectedDate + ' '  + loc.monday_to_friday_opening_time));
                            loc_close_time = new Date(Date.parse(self.appointmentData.selectedDate + ' '  + loc.monday_to_friday_closing_time));
                            if(!(dropTime >= loc_open_time && dropTime <= loc_close_time)){
                                self.dropTimeError = 'Store time is ' + loc.monday_to_friday_opening_time + '-' + loc.monday_to_friday_closing_time + '. Please select between that.';
                                checked = false;
                            }
                        }
                    }
                });
                // let loc_open_time = new Date(Date.parse(self.appointmentData.selectedDate + ' '  + '06:00 AM'));
                // let loc_close_time = '';
                // if(day_name == 'Sunday'){
                //     self.showSAlert('Not Available!', '', false);
                //     checked = false;
                // }else if(day_name == 'Saturday'){
                //     loc_close_time = new Date(Date.parse(self.appointmentData.selectedDate + ' '  + '12:00 PM'));
                //     if(!(dropTime >= loc_open_time && dropTime <= loc_close_time)){
                //         self.dropTimeError = 'Store time is 06:00 AM - 12:00 PM. Please select between that.';
                //         checked = false;
                //     }
                // }else{
                //     loc_close_time = new Date(Date.parse(self.appointmentData.selectedDate + ' '  + '06:00 PM'));
                //     if(!(dropTime >= loc_open_time && dropTime <= loc_close_time)){
                //         self.dropTimeError = 'Store time is 06:00 AM - 06:00 PM. Please select between that.';
                //         checked = false;
                //     }
                // }
                return checked;
            },
            resetAppointmentData(){
                self.isPrevNextClicked = false;
                self.isServiceTypeHoursChanged = false;
                
                // $.each(self.locationOptions, function (key, loc) {
                //     if(loc.value == 23){
                //         self.appointmentData.location = loc;
                //     }
                // });
                self.appointmentData.location = '';
                self.appointmentData.department = null;
                self.appointmentData.make = '';
                self.appointmentData.model = '';
                self.appointmentData.makeOtherDetail = '';
                self.appointmentData.service_data.service_type = {'text': '15K', 'value': 3};
                self.appointmentData.service_data.other_make_service_type = '';
                self.appointmentData.service_data.freightliner_service_type = [];
                self.appointmentData.service_data.service_description = '';

                self.appointmentData.isCustomerNew = false;
                self.appointmentData.reg_no = '';
                self.appointmentData.year = '';
                self.appointmentData.odomIn = '';
                self.appointmentData.cus_name = '';
                self.appointmentData.cus_contact_no = '';
                self.appointmentData.cus_email = '';
                self.appointmentData.preferredDropTime = '07:30 AM';
                self.appointmentData.selectedDate = '';
                self.appointmentData.totalJobHours = 0.0;
                self.appointmentData.lastSelectedDate = '';
                self.appointmentData.unsold_hrs = '';
                self.appointmentData.customer_id = '';
                self.appointmentData.vin = '';
                self.appointmentData.fleet_unit_id = null;

                $('#customer-details-tab').removeClass('done');
                $('#select-services-tab').removeClass('done');
                $('#select-date-tab').removeClass('done');

                $("#customer-details-tab").css('pointer-events', 'auto');
                $("#select-services-tab").css('pointer-events', 'auto');
                $("#select-date-tab").css('pointer-events', 'auto');

                if(self.isTouchDevice){
                    $('.fc-day-top').removeClass('fc-highlight');
                    $('.fc-bg .fc-day').removeClass('fc-highlight');
                }else{
                    self.$refs.calendar.fireMethod('unselect');
                }

                let params = JSON.parse(localStorage.getItem('urlParams'));
                if (params && params.vin && params.reg_id != 'null') {
                    self.getServiceBookingDetails(params);
                }

                self.moveToCusDetailsPage();
                self.firstCheckCalendarEvents = true;
                self.getCalendarEvents();

                $('#Overbooked_notification_for_calendar').addClass('hidden');
            },

            moveToCusDetailsPage(){
                $('#booking_title').show();
                $('#select-services-tab').removeClass('active');
                $('#select-date-tab').removeClass('active');
                $('#select_services').addClass('fade');
                $('#select_date').addClass('fade');
                $('#select_services').hide();
                $('#select_date').hide();
                $('#customer-details-tab').addClass('active');
                $('#customer_details').removeClass('fade');
                $('#customer_details').show();

                $('#Overbooked_notification_for_calendar').addClass('hidden');
            },

            moveToSelectServicePage(){
                console.log('moveToSelectServicePage')
                if(!self.validateCusDetails()){
                    $('#customer-details-tab').addClass('active');
                    $('#select-services-tab').removeClass('active');
                    $('#select-services-tab').removeClass('show');
                    return;
                }
                if(self.appointmentData.make.value == 1){
                    if(self.appointmentData.service_data.freightliner_service_type.length == 0){
                        self.isServiceSelected = false;
                    }
                }else{
                    if(!self.appointmentData.service_data.service_type){
                        self.isServiceSelected = false;
                    }
                }
                if(!self.isServiceSelected){
                    // self.getServiceTimes();
                    self.isServiceSelected = true;
                }
                $('#customer-details-tab').addClass('done');

                $('#customer-details-tab').removeClass('active');
                $('#customer_details').addClass('fade');
                $('#customer_details').hide();

                $('#select-date-tab').removeClass('active');
                $('#select_date').addClass('fade');
                $('#select_date').hide();

                $('#select-services-tab').addClass('active');
                $('#select_services').show();
                $('#select_services').removeClass('fade');

                $('#Overbooked_notification_for_calendar').addClass('hidden');
                let params = JSON.parse(localStorage.getItem('urlParams'));
                if (params && params.odom_in) {
                    self.appointmentData.service_data.service_type = self.serviceTypeOptions.find(option => option.text === params.odom_in);
                }
            },

            moveToSelectDatePage(){
                console.log('moveToSelectDatePage')
                if(!self.validateService()){
                    return;
                }
                self.calculateTotalJobHours();
                if(self.isServiceTypeHoursChanged){
                    self.$refs.calendar.fireMethod('today');
                    if(self.isTouchDevice){
                        $('.fc-day-top').removeClass('fc-highlight');
                        $('.fc-bg .fc-day').removeClass('fc-highlight');
                    }else{
                        self.$refs.calendar.fireMethod('unselect');
                    }
                    self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
                    self.endDate = self.$refs.calendar.fireMethod('getView').end.format();
                    self.isPrevNextClicked = false;
                    self.appointmentData.lastSelectedDate = '';
                }
                self.getCalendarEvents();

                $('#select-services-tab').addClass('done');

                $('#select-services-tab').removeClass('active');
                $('#select_services').addClass('fade');
                $('#select_services').hide();

                $('#customer-details-tab').removeClass('active');
                $('#customer_details').addClass('fade');
                $('#customer_details').hide();

                $('#select-date-tab').addClass('active');
                $('#select_date').show();
                $('#select_date').removeClass('fade');

                $('#booking_title').show();
                $('#booking_appointment').show();
                $('#booking_success').hide();
            },

            moveToBookingSuccessPage(){
                var selectDate = moment(self.appointmentData.selectedDate).format("YYYY-MM-DD");
                var currentDate = moment(new Date()).format("YYYY-MM-DD");
                if(!self.validateDateDetails()){
                    return;
                }
                let date = moment(self.appointmentData.selectedDate).format("DD/MM/YYYY");
                this.$swal({
                    title: 'Confirming: you want to book ' + self.appointmentData.reg_no + ' for a service at ' + date + ' ' + self.appointmentData.preferredDropTime + '?',
                    html: '',
                    type: '',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Book!',
                    cancelButtonText: 'No',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.saveAppointmentData()
                    }
                })
            },

            selectDateTabClicked(){
                $('#booking_title').show();
                $('#booking_appointment').show();
                $('#booking_success').hide();
            },

            fetchDetailsFromExcede(){
                let registrationNo = self.appointmentData.reg_no;
                if(registrationNo.length>3){
                    var config = {
                    };
                    var fields = {
                        reg_no: registrationNo
                    };
                    HTTP.post('/excede/customer/byRegNo', fields, config)
                    .then((response)=>{
                        console.log('response ',response.data)
                        if(response.data.code == 200) {
                            let params = JSON.parse(localStorage.getItem('urlParams'));
                            console.log('params ',params)
                            if (Object.keys(params).length !== 0) {
                                console.log('in params')
                                if (response.data.content.excede_id == params.cus_id) {
                                    self.appointmentData.year = response.data.vehicle.ModelYear;
                                    self.appointmentData.cus_name = response.data.content.name;
                                    self.appointmentData.customer_id = response.data.content.excede_id;
                                    self.appointmentData.vin = response.data.vehicle.Vin;
                                    self.appointmentData.fleet_unit_id = params.fleet_unit;
                                    if (response.data.content.work_phone) {
                                        self.appointmentData.cus_contact_no = response.data.content.work_phone;
                                    } else {
                                        self.isPhoneDisabled = false;
                                    }
                                    if (response.data.content.work_email) {
                                        self.appointmentData.cus_email = response.data.content.work_email;
                                    } else {
                                        self.isEmailDisabled = false;
                                    }
                                } else {
                                    self.$swal('Cancelled', 'Customer is different for you entered Registration Id. To book appointment, Please contact your Administration', 'info');
                                }
                            } else {
                                self.appointmentData.year = response.data.vehicle.ModelYear;
                                self.appointmentData.cus_name = response.data.content.name;
                                self.appointmentData.vin = response.data.vehicle.Vin;
                                self.appointmentData.customer_id = response.data.content.excede_id;
                                self.appointmentData.fleet_unit_id = response.data.vehicle.FleetUntId;
                                if (response.data.content.work_phone) {
                                    self.appointmentData.cus_contact_no = response.data.content.work_phone;
                                } else {
                                    self.isPhoneDisabled = false;
                                }
                                if (response.data.content.work_email) {
                                    self.appointmentData.cus_email = response.data.content.work_email;
                                } else {
                                    self.isEmailDisabled = false;
                                }
                            }
                        }else if(response.data.code == 201){
                            self.$swal('Cancelled', 'Your Vehicle Not Found', 'info');
                        }
                    })
                    .catch((err)=>{
                        console.log(error);
                    });
                }
            },
            calculateTotalJobHours(){
            self.isServiceTypeHoursChanged = false;
            let lastTotalJobHours = self.appointmentData.totalJobHours;
                if(self.appointmentData.make.value == 1){ //make is freightliner
                    let service_type = '';
                    if(self.appointmentData.service_data.freightliner_service_type.includes("Other/Unsure")){
                        self.appointmentData.totalJobHours = 8.00;
                        service_type = 'Other';
                    }else{
                        self.appointmentData.totalJobHours = 0.00;
                        $.each(self.appointmentData.service_data.freightliner_service_type, function (key, model) {
                            $.each(self.serviceTypeOptions, function (key1, type) {
                                if(type.text == model){
                                    self.appointmentData.totalJobHours += type.value;
                                    service_type = service_type + ' ' + type.text;
                                }
                            });
                        });
                    }
                    self.appointmentData.job_make_detail = self.appointmentData.make.text + ' - ' 
                                + self.appointmentData.model.text + ' - ' + service_type + ' - ' + self.appointmentData.totalJobHours;
                }else if(self.appointmentData.make.value == 0){ //make is other
                    self.appointmentData.totalJobHours = 0.00;
                    self.appointmentData.job_make_detail = self.appointmentData.make.text + ' - ' 
                                + self.appointmentData.makeOtherDetail + ' - ' + self.appointmentData.service_data.other_make_service_type + self.appointmentData.totalJobHours;
                }else{
                    self.appointmentData.totalJobHours = self.appointmentData.service_data.service_type.value;
                    self.appointmentData.job_make_detail = self.appointmentData.make.text + ' - ' 
                                + self.appointmentData.model.text + ' - ' + self.appointmentData.service_data.service_type.text + ' - ' + self.appointmentData.totalJobHours;
                }
                if(lastTotalJobHours != self.appointmentData.totalJobHours){
                    self.isServiceTypeHoursChanged = true;
                }
            },

            saveAppointmentData(){
                if(typeof(self.appointmentData.unsold_hrs) != undefined && self.appointmentData.unsold_hrs < self.appointmentData.totalJobHours){
                    self.showSAlert('Selected service type hours are not available for same day please choose another date!', '', false);
                    return false;
                }
                // let department_id = process.env.SERVICE_DEPARTMENT_ID;
                // if(!department_id){
                //     department_id = 9;
                // }
                // self.appointmentData.department_id = department_id;
                // self.calculateTotalJobHours();
                
                var config = {
                    headers: {
                    }
                };
                var fields = {
                    appointmentData: self.appointmentData,
                };
                HTTP.post('/saveAppointmentData', fields, config)
                .then((response)=>{
                    if(response.data.code == 200) {
                        $('#select-date-tab').addClass('done');
                        $('#booking_title').hide();
                        $('#booking_appointment').hide();
                        $('#booking_success').show();

                        $("#customer-details-tab").css('pointer-events', 'none');
                        $("#select-services-tab").css('pointer-events', 'none');
                        $("#select-date-tab").css('pointer-events', 'none');
                    }else{
                        alert("Error while saving appointment,Please try after some time.");
                    }
                })
                .catch((err)=>{
                    console.log(error);
                    return false;
                });
            },
            getCalendarEventsWithPromise(){
                var config = {
                };
                // let department_id = process.env.SERVICE_DEPARTMENT_ID;
                // if(!department_id){
                //     department_id = 1;
                // }
                var fields = {
                    start_date: self.startDate,
                    end_date: self.endDate,
                    location_id: self.appointmentData.location.value,
                    department_id: self.appointmentData.department.value,
                    is_from_excede: 0,//tss,excede,both
                };
                self.showLoader();
                return new Promise((resolve, reject) => {
                    HTTP.post('/getCalendarEvents', fields, config)
                        .then(response => {
                            resolve(response);
                        });
                    });
            },
            getCalendarEvents(){
                console.log('getCalendarEvents')
                let result = self.getCalendarEventsWithPromise();
                if (isPromise(result) == true) {result
                    .then(data => {
                        self.events = data.data.content;
                        self.holidayList = data.data.disabled_holiday;

                        //This logic is added to calculate selected service's total job hours and basis of it enable/disable date.
                        self.calculateTotalJobHours();
                        let showOvebookedNotification = false;
                        if(!self.isPrevNextClicked){
                            if(self.firstCheckCalendarEvents){
                                if(self.check3weeksBooked()){
                                    self.allowOnlineBooking = false;
                                }
                            }else{
                                if(self.check3weeksBooked()){
                                    $('#select_date').addClass('fade');
                                    $('#select_date').hide();
                                    $('#Overbooked_notification_for_calendar').removeClass('hidden');
                                    $('#Overbooked_notification_for_calendar').show();
                                    showOvebookedNotification = true;
                                }else{
                                    $('#select_date').addClass('active');
                                    $('#select_date').show();
                                    $('#select_services').removeClass('fade');
                                    $('#Overbooked_notification_for_calendar').addClass('hidden');
                                    $('#Overbooked_notification_for_calendar').hide();
                                }
                            }
                        }
                        self.firstCheckCalendarEvents = false;

                        let disabled_date = false;
                        let isSelecteddateDisabled = false;
                        var selectedDate = self.appointmentData.selectedDate ? self.appointmentData.selectedDate : self.appointmentData.lastSelectedDate
                        selectedDate = moment(selectedDate).format("YYYY-MM-DD");
                        $.each(self.events, function (i) {
                            disabled_date = false;
                            if(self.events[i].backgroundColor == "#fc0320"){
                                if(self.events[i].start == selectedDate){
                                    isSelecteddateDisabled = true;
                                }
                                $('.fc-day[data-date="' + self.events[i].start + '"]').css('background-color', "#D3D3D3");
                                disabled_date = true;
                            }
                            if(self.holidayList.includes(self.events[i].start)){
                                if(self.events[i].start == selectedDate){
                                    isSelecteddateDisabled = true;
                                }
                                $('.fc-day[data-date="' + self.events[i].start + '"]').css('background-color', "#D3D3D3");
                                disabled_date = true;
                            }
                            if(typeof(self.events[i].unsold_hrs) == undefined || self.events[i].unsold_hrs < self.appointmentData.totalJobHours){
                                if(self.events[i].start == selectedDate){
                                    isSelecteddateDisabled = true;
                                }
                                $('.fc-day[data-date="' + self.events[i].start + '"]').css('background-color', "#D3D3D3");
                                disabled_date = true;
                            }
                            if(!disabled_date){
                                $('.fc-day[data-date="' + self.events[i].start + '"]').css('background-color', "#d0edff");
                            }
                        });
                        if(isSelecteddateDisabled && !showOvebookedNotification){
                            if(self.isTouchDevice){
                                $('.fc-day-top').removeClass('fc-highlight');
                                $('.fc-bg .fc-day').removeClass('fc-highlight');
                                alert('Selected date is not Available! Please select another date');
                            }else{
                                self.$refs.calendar.fireMethod('unselect');
                                self.showSAlert('Selected date is not Available! Please select another date', '', false);
                            }
                            self.appointmentData.selectedDate = '';
                        }
                        $('.fc-past').css('background-color', "#D3D3D3");

                        let startDate = new Date(self.startDate);
                        let endDate = new Date(self.endDate);

                        self.isAllSaturdayDisable = false;
                        $.each(self.locationOptions, function (key, loc) {
                            if(loc.value == self.appointmentData.location.value){
                                if(!(loc.saturday_opening_time && loc.saturday_closing_time)){
                                    self.isAllSaturdayDisable = true;
                                }
                            }
                        });

                        while (startDate <= endDate) {
                            if (startDate.getDay() == 0) { // 0 represents Sunday
                                let date = moment(startDate).format("YYYY-MM-DD").toString();
                                $('.fc-day[data-date="' + date + '"]').css('background-color', "#D3D3D3");
                            }
                            if(startDate.getDay() == 6 && self.isAllSaturdayDisable){
                                let date = moment(startDate).format("YYYY-MM-DD").toString();
                                $('.fc-day[data-date="' + date + '"]').css('background-color', "#D3D3D3");
                            }
                            startDate.setDate(startDate.getDate() + 1); // Increment date by one day
                        }
                        self.hideLoader();
                    })
                    .catch((err)=>{
                        self.hideLoader();
                        console.log(err);
                    });
                }
            },
            getServiceBookingDetails (params) {
                self.showLoader();
                var config = {
                    headers: {
                    },
                    params: {
                        vin: params.vin,
                        regId: params.reg_id
                    }
                };
                let SSO_URL = process.env.SSO_ROOT_URL;
                HTTP.get(SSO_URL + "/api/get-service-booking-details", config)
                    .then(function (response) {
                        self.hideLoader();
                        if (!response.data) {
                            self.showSAlert('customer is not found', '', false);
                        } else {
                            let params = JSON.parse(localStorage.getItem('urlParams'));
                            self.appointmentData.reg_no = params.reg_id;
                            self.appointmentData.vin = params.vin;
                            self.appointmentData.cus_name = response.data.customer_name;
                            if (response.data.customer_phone) {
                                self.appointmentData.cus_contact_no = response.data.customer_phone;
                            } else {
                                self.isPhoneDisabled = false;
                            }
                            if (response.data.customer_email) {
                                self.appointmentData.cus_email = response.data.customer_email;
                            } else {
                                self.isEmailDisabled = false;
                            }
                            self.appointmentData.customer_id = response.data.customer_id;
                            self.appointmentData.year = response.data.year;
                            self.appointmentData.fleet_unit_id = params.fleet_unit;
                        }
                    })
                    .catch(function (error) {
                        self.hideLoader();
                        console.log(error);
                    })
            },
            onLocationChange () {
                self.appointmentData.department = null;
                if (self.appointmentData.location && self.appointmentData.location.value) {
                    self.locationError = null;
                    self.showLoader();
                    var config = {
                        headers: {
                        },
                        params: {
                            location_id: self.appointmentData.location.value
                        }
                    };
                    HTTP.get("getDepartment", config)
                        .then(function (data) {
                            self.hideLoader();
                            if (data.status == 200) {
                                self.departmentOptions = data.data.content;
                                // $.each(self.departmentOptions, function (key, dep) {
                                //     if(dep.text == 'Fuso Canter Only'){
                                //         self.appointmentData.department = dep;
                                //     }
                                // });
                            }
                        })
                        .catch(function (error) {
                            self.hideLoader();
                            console.log(error);
                        })
                }
            },
            onDepartmentChange () {
                self.departmentError = null;
            }
        }
    }
    $(document).ready(function() {        
        $('.serviceCalendar .fc-prev-button').click(function(event){
            self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
            self.endDate = self.$refs.calendar.fireMethod('getView').end.format();
            self.isPrevNextClicked = true;
            self.appointmentData.lastSelectedDate = self.appointmentData.selectedDate;
            if(self.isTouchDevice){
                if(self.appointmentData.selectedDate != ''){
                    $("td[data-date=" + self.appointmentData.selectedDate + "]").addClass('fc-highlight');
                }
            }else{
                self.$refs.calendar.fireMethod('select',self.appointmentData.selectedDate);
            }
            self.getCalendarEvents();
        });

        $('.serviceCalendar .fc-next-button').click(function(event){
            self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
            self.endDate = self.$refs.calendar.fireMethod('getView').end.format();
            self.isPrevNextClicked = true;
            self.appointmentData.lastSelectedDate = self.appointmentData.selectedDate;
            if(self.isTouchDevice){
                if(self.appointmentData.selectedDate != ''){
                    $("td[data-date=" + self.appointmentData.selectedDate + "]").addClass('fc-highlight');
                }
            }else{
                self.$refs.calendar.fireMethod('select',self.appointmentData.selectedDate);
            }
            self.getCalendarEvents();
        });
    });

</script>
<style scoped>
.not-available-color {
    float:left;
    margin-left:20px;
    margin-bottom:10px;
    width: 15px;
    height: 15px;
    background-color: #D3D3D3;
}
.color-text{
    margin-left: 10px;
    float: left;
    display: block;
    line-height: 12px;
}
.selected-color {
    float:left;
    margin-left:20px;
    margin-bottom:10px;
    width: 15px;
    height: 15px;
    background-color: #57bf82;
}
.available-color {
    float:left;
    margin-left:20px;
    margin-bottom:10px;
    width: 15px;
    height: 15px;
    background-color: #d0edff;
}
.static_note {
  color: #076eb0 !important;
  text-align: center;
}
.disabled_button{
    background: #D3D3D3;
    border: 1px solid #D3D3D3 !important;
    color: #fff;
    pointer-events: auto;
}
.hidden {
    display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Booking.vue